// extracted by mini-css-extract-plugin
export default {"icon":"e983e24828a83c2b","deliverableInfoWrapper":"_3269f8b0f2bee01d"};